<template>
  <div class="news">
    <link rel="stylesheet" href="https://pro.fontawesome.com/releases/v5.14.0/css/all.css" integrity="sha384-VhBcF/php0Z/P5ZxlxaEx1GwqTQVIBu4G4giRWxTKOCjTxsPFETUDdVL5B6vYvOt" crossorigin="anonymous">
    <div class="kroppensContainer">
      <div class="newsContainer">
        <div class="articles">
          <p class="heading" v-if="this.$root.admin">
            <font-awesome-icon :class="['settings', settingsMode ? 'active' : '']" @click="settingsMode = !settingsMode" v-if="this.$root.admin" :icon="['fas', 'cog']" />
          </p>
          <settingsComponent @newSettings="newSettings" v-if="settingsMode && this.$root.admin" :contentid="contentid" :saving="saving" :settings="this.$root.settings"></settingsComponent>
          <transition-group name="bounce" tag="section">
            <article class="newsItem" v-for="(item, index) in items" :key="index+1">
              <div class="newsItemInner">
                <a  :href="basedir+item.urlPrefix+item.url.replace('?','#')">
                <div class="newsItemImage ingredientImage" :style="'background-image: url('+basedir+item.imageUrl+'?w=336'+');'">
                  
                </div>
                  <div class="contentSnippet">
                    <h5 v-bind:style="{ fontSize: item.headers.length >= 26 ? 1+'em' : 1.5+'em' }">{{item.headers}}</h5>
                    <p>{{item.description.length > 80 ? item.description.slice(0, 80)+"..." : item.description}}</p>
                  </div>
                 <div class="readMoreLinkfooterCard" >{{$root.translations.wsm_ReadMore}}</div>
                    <script type="application/ld+json">
                      {
                        "@context": "http://schema.org",
                        "@type": "NewsArticle",
                        "mainEntityOfPage": {
                          "@type": "WebPage",
                          "@id": "{{location}}"
                        },
                        "headline": {{ JSON.stringify(item.headers)}},
                        "image": [
                          "{{item.imageUrl.indexOf('http') < 0 ? location+basedir+item.imageUrl : item.imageUrl}}"
                        ],
                        "datePublished": "{{new Date(item.publicationDate).toISOString().slice(0, 10)}}",
                        "dateModified": "{{new Date(item.publicationDate).toISOString().slice(0, 10)}}",
                        "author": {
                          "@type": "Organization",
                          "name": "Pharma Nord"
                        },
                        "publisher": {
                          "@type": "Organization",
                          "name": "Pharma Nord",
                          "logo": {
                            "@type": "ImageObject",
                            "url": "{{location+basedir}}/static/CKFinderJava/userfiles/images/2014/general/Logo-PN-no-slogan-0514.png"
                          }
                        },
                        "description": {{JSON.stringify(item.description)}}
                      }
                    </script>
                  </a>
              </div>
            </article>
          </transition-group>
        </div>
        <button v-if="showMore" class="loadMoreNews" @click="getArticles((parseInt(items.length)+parseInt($root.settings.default)));"><i :class="[loading ? 'fad fa-spinner fa-spin' : 'fad fa-angle-double-down']"></i> {{$root.translations.wsm_ShowMore}}</button>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import settingsComponent from './settings.vue'
  export default {
    name: 'Ingredients',
    components: {
      axios,
      settingsComponent,
    },
    data() {
      return {
        items: [],
        showMore: false,
        settingsMode: false,
        id: this.$root.settings.idForSection,
        saving: false,
        contentid: this.$root.contentid,
        loading: false,
      }
    },
    mounted() {
      this.getArticles(this.$root.settings.default)
    },
    methods: {
      newSettings: function(val) {
        this.items = [];
        this.id = val.id;
        this.getArticles(val.amount);
      },
      getArticles: function(amount) {
        this.loading = true;
        var requestObj = {
          target: {
            news: {
              tagId: this.id, //News section
              noOfResults: amount
            }
          }
        }
        if (!isNaN(this.$root.cat)) {
          requestObj["attributeValueIds"] = [this.$root.cat];
          requestObj["newsId"] = 0;
          requestObj.target.news.noOfResults = 99999;
        }
        axios.post(this.basedir + "/ajaxRequestServlet?mode=Search", JSON.stringify(requestObj), {
          headers: {
            'Content-Type': 'application/json',
          }
        }).then(response => {
          this.showMore = false;
          this.items = response.data.news.sort(function(a, b) {
            var textA = a.headers.toUpperCase();
            var textB = b.headers.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
          });
          this.loading = false;
          if ((isNaN(this.$root.cat) && this.items.length >= parseInt(this.$root.settings.default)) && this.items.length < response.data.total) {
            setTimeout(() => {
              this.showMore = true;
            }, 600)
          } else {
            this.showMore = false;
          }
        })
      }
    },
    computed: {
      basedir: function() {
        return basedir;
      },
      locale: function() {
        return window.locale.replace('_', '-')
      },
      location: function() {
        return window.location.origin;
      },
    }
  }
</script>

<style>
  body,
  html {
    scroll-behavior: smooth;
  }
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .kroppensContainer,
  .kroppensContainer *{
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
  }
    
  .articles {
    margin: 0 auto;
    display: block;
    text-align: left;
  }
  section{
    margin: 0 -15px !important;
 
   &>span {
      	text-align: center;
        display: block;
        margin: 0 auto;
    } 
  }
  article {
    .newsItemInner{
      overflow:hidden;
      min-width: 286px;
      min-height: auto; /*393px*/
      background: white;
      vertical-align: top;
      position: relative;
      box-shadow: 1px 1px 20px 0px #d0d0d0;
      border-radius: 12px;
      padding: 0;
      transition: all 0.2s ease-in-out;
      .newsItemImage{
        transition: all 0.2s ease-in-out !important;
      }
      &:hover .newsItemImage {
        background-size:110%;
        //box-shadow: 1px 1px 20px 0px #8a8a8a;
      }
    

    }
    .readMoreLinkfooterCard {
      position: absolute;
      bottom: 0;
      padding: 12px 0px 12px 0px;
      text-align: center;
      background: #004570;
      width: 100%;
      border-bottom-left-radius: 12px;
      border-bottom-right-radius: 12px;
      margin-bottom: 0;
      color: white;
      font-weight: bold;
      transition: all 0.2s ease-in-out;
      &:hover {
        background: #005c96;
      }
    }
    .ingredientImage {
      height: 171px;
      display: block;
      background-size: 105%;
      background-position: center;
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
      border-bottom: 4px solid #e8b75e;
      margin-bottom: 0;
    }
    img {
      width: 100%;
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
    }
    h5 {
      	font-size: 1.5em;
      margin-bottom: 5px;
      color: #2e606b;
      	word-break: break-word;
      text-align: center;
    }
    .contentSnippet {
      width: 100%;
      padding: 15px;
      display: block;
      	min-height: 146px;
      margin-bottom: 47px;
      p {
        text-align: center;
        color: #6d6d6d;
      }
    }
    .articleImage {
      vertical-align: top;
      width: 40%;
      display: inline-block;
      img {
        width: 87%;
        margin-right: 16px;
        vertical-align: top;
      }
    }
  }
  .loadMoreNews {
    width: 100%;
    padding: 10px;
    color: white;
    background: #7caf63;
    cursor: pointer;
    border: none;
    border-radius: 2px;
    &:hover {
      background: rgb(134, 190, 106);
    }
    i {
      color: white;
      margin-right: 6px;
    }
  }
  article { 
    padding:15px;
    display: inline-block;
    width: calc(100% / 3);
    text-align: left;
    min-height: 376px;
  }
  article .newsItemInner {
    display: inline-block;
    width: 100%;
    text-align: left;
    margin-bottom: 22px;
  }
  @media only screen and (max-width: 950px) {
    article { 
      padding:15px;
      display: inline-block;
      width: calc(100% / 2);
    }
  }
  
  @media only screen and (max-width: 650px) {
    article { 
      padding:15px;
      display: inline-block;
      width: 100%;
      height:auto;
      min-height: unset;
    }
  }
  // @media only screen and (max-width: 950px) {
  //   #content article.newsItem {
  //     border-right: none !important;
  //     min-height: auto;
  //     a img {
  //       float: left !important;
  //       width: 100%;
  //       margin-top: 0 !important;
  //     }
  //   }
  //   article.newsItem {
  //     width: 45% !important;
  //     a img {
  //       float: left !important;
  //       width: 100%;
  //       margin-top: 0 !important;
  //     }
  //     .contentSnippet {
  //       float: right !important;
  //       width: 100%;
  //       margin-bottom: 20px;
  //     }
  //   }
  // }
  // @media only screen and (max-width: 700px) {
  //   .ingredientImage {
  //     margin-bottom: 0;
  //   }
  //   #content article.newsItem {
  //     border-right: none !important;
  //     padding: 0;
  //     width: 98% !important;
  //     min-height: auto;
  //     a img {
  //       width: 100%;
  //       float: none;
  //     }
  //     .contentSnippet {
  //       width: 100%;
  //       float: none !important;
  //       margin-bottom: 44px;
  //     }
  //   }
  // }
  .bounce-enter-active {
    animation: bounce-in .2s;
  }
  .bounce-leave-active {
    animation: bounce-in .2s reverse;
  }
  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
  .heading {
    color: #00456f;
    font-weight: bold;
  }
  .settings {
    cursor: pointer;
    float: right;
    margin-top: 4px;
    font-weight: bold;
    transition: all 0.2s ease-in-out;
    &:hover {
      transform: scale(1.1)
    }
  }
  .settings.active {
    color: #4cad16;
  }
  .heading {
    height: 25px;
  }
</style>
